/**
 * @fileoverview gRPC-Web generated client stub for grpc.health.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.27.2
// source: Health.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as Health_pb from './Health_pb'; // proto import: "Health.proto"


export class HealthClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCheck = new grpcWeb.MethodDescriptor(
    '/grpc.health.v1.Health/Check',
    grpcWeb.MethodType.UNARY,
    Health_pb.HealthCheckRequest,
    Health_pb.HealthCheckResponse,
    (request: Health_pb.HealthCheckRequest) => {
      return request.serializeBinary();
    },
    Health_pb.HealthCheckResponse.deserializeBinary
  );

  check(
    request: Health_pb.HealthCheckRequest,
    metadata?: grpcWeb.Metadata | null): Promise<Health_pb.HealthCheckResponse>;

  check(
    request: Health_pb.HealthCheckRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: Health_pb.HealthCheckResponse) => void): grpcWeb.ClientReadableStream<Health_pb.HealthCheckResponse>;

  check(
    request: Health_pb.HealthCheckRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: Health_pb.HealthCheckResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/grpc.health.v1.Health/Check',
        request,
        metadata || {},
        this.methodDescriptorCheck,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/grpc.health.v1.Health/Check',
    request,
    metadata || {},
    this.methodDescriptorCheck);
  }

  methodDescriptorWatch = new grpcWeb.MethodDescriptor(
    '/grpc.health.v1.Health/Watch',
    grpcWeb.MethodType.SERVER_STREAMING,
    Health_pb.HealthCheckRequest,
    Health_pb.HealthCheckResponse,
    (request: Health_pb.HealthCheckRequest) => {
      return request.serializeBinary();
    },
    Health_pb.HealthCheckResponse.deserializeBinary
  );

  watch(
    request: Health_pb.HealthCheckRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<Health_pb.HealthCheckResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/grpc.health.v1.Health/Watch',
      request,
      metadata || {},
      this.methodDescriptorWatch);
  }

}

